import { httpClient } from './httpClient';
import type { PaymentIntentRedirectResponseBody } from './schema';

export async function getPaymentIntentRedirect(
  redirectToken: string
): Promise<PaymentIntentRedirectResponseBody> {
  const { data, error } = await httpClient.GET('/payments/v2/intent/redirect', {
    headers: { Authorization: `Bearer ${redirectToken}` }
  });

  if (error) throw error;
  if (!data) throw new Error('No data returned from the API');
  return data;
}
